

































































































import QuoteStateMixin from '@/mixins/quoteState';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { mapActions } from 'vuex';
import { QuoteState, QuoteType } from '@/models/quote';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default mixins(QuoteStateMixin, auth).extend({
  components: { ErrorAlert },
  name: 'QuoteApproval4PendingStateCard',

  computed: {
    getColor(): string {
      return 'submitted';
    },

    getIcon(): string {
      return 'mdi-alert-circle-check-outline';
    },

    getString(): string {
      let approval_level = 'CEO';
      if (this.isQuoteVentilation) {
        approval_level += ' or CCO';
      }
      return `${approval_level} Approval Pending`;
    },

    getActionText(): string {
      return 'Approve';
    },

    isQuoteVentilation(): boolean {
      return (
        this.quote.type == QuoteType.RTU_VENTILATION ||
        this.quote.type == QuoteType.AIRWAY_VENTILATION
      );
    }
  },

  data: () => ({
    loading: false
  }),

  methods: {
    ...mapActions({
      setQuoteState: 'quote/setQuoteState'
    }),

    approve() {
      this.clearAllErrors();
      this.loading = true;
      const state = QuoteState.APPROVED;

      this.setQuoteState({ id: this.quote.number, state })
        .then(({ state }) => {
          this.$emit('state-changed:quote', {
            number: this.quote.number,
            revision: this.quote.revision,
            state: state
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
